import React, { useEffect, useState } from "react";
import AnalyticsChart from "./components/chartComponent/AnalyticsChart";
import BadgeDetails from "./components/currentBadgeComponent/userBadgesDetails";
import { useLocation } from "react-router-dom";
import { fetchRewardDashboard } from "../../store/reducers/rewardDashboard";
import { useDispatch } from "react-redux";

const RewardDashBoard = () => {
  const location = useLocation();
  const [isUserDetails, setIsUserDetails] = useState(false);
  const [userId, setUserId] = useState(null);
  const organizationId = localStorage.getItem("organisation_id");
  const dispatch = useDispatch();

  useEffect(() => {
    const path = location.pathname;
    const match = path.match(/employee-progress\/(\d+)/);

    if (match) {
      setIsUserDetails(true);
      setUserId(match[1]);
    } else {
      setIsUserDetails(false);
      const localUserId = localStorage.getItem("user_id");
      setUserId(localUserId);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (userId && organizationId) {
      dispatch(fetchRewardDashboard({ userId: +userId, organizationId: +organizationId }));
    }
  }, [userId, organizationId, dispatch]);

  return (
    <div style={{ padding: "1rem" }}>
      <BadgeDetails isUserDetails={isUserDetails} />
      <AnalyticsChart style={{ marginTop: "20px" }} userId={+userId} organizationId={+organizationId} />
    </div>
  );
};

export default RewardDashBoard;
